// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","dark":"rgb(27, 27, 27)","outer":"_1nr9","title":"_27XX","list":"_1EvJ","listItem":"NQ8e","marker":"_3nrV","active":"_35NR","text":"_3omz","disabled":"_2e7D"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/TimelineList/TimelineList.scss
// module id = +omH
// module chunks = 0